var _defs, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbleFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.63 22.874c2.045-8.543-3.221-17.126-11.762-19.171-8.54-2.045-17.122 3.222-19.166 11.765-2.045 8.543 3.222 17.126 11.762 19.171 8.54 2.045 17.122-3.222 19.166-11.765z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.92 16.69h-2.382v-1.555c.156-1.502 2.642-1.191 2.642-1.191v-2.539c-.104 0-4.869-1.14-5.853 2.487-.155.466-.155 2.539-.155 2.798H15.1v2.797h2.175v7.617h3.16v-7.616h2.486l.259-2.798h-.26z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleFacebook);
export default __webpack_public_path__ + "static/media/bubble-facebook.b8218938.svg";
export { ForwardRef as ReactComponent };